import { render, staticRenderFns } from "./ProvTradeCancel.vue?vue&type=template&id=2a055732&scoped=true&"
import script from "./ProvTradeCancel.vue?vue&type=script&lang=js&"
export * from "./ProvTradeCancel.vue?vue&type=script&lang=js&"
import style0 from "./ProvTradeCancel.vue?vue&type=style&index=0&id=2a055732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a055732",
  null
  
)

export default component.exports